// src/utils/cn.ts
import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";
function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// ../../node_modules/lucide-react/dist/esm/createLucideIcon.js
import { forwardRef as forwardRef2, createElement as createElement2 } from "react";

// ../../node_modules/lucide-react/dist/esm/shared/src/utils/mergeClasses.js
var mergeClasses = (...classes) => classes.filter((className, index, array) => {
  return Boolean(className) && className.trim() !== "" && array.indexOf(className) === index;
}).join(" ").trim();

// ../../node_modules/lucide-react/dist/esm/shared/src/utils/toKebabCase.js
var toKebabCase = (string) => string.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();

// ../../node_modules/lucide-react/dist/esm/shared/src/utils/toCamelCase.js
var toCamelCase = (string) => string.replace(
  /^([A-Z])|[\s-_]+(\w)/g,
  (match, p1, p2) => p2 ? p2.toUpperCase() : p1.toLowerCase()
);

// ../../node_modules/lucide-react/dist/esm/shared/src/utils/toPascalCase.js
var toPascalCase = (string) => {
  const camelCase = toCamelCase(string);
  return camelCase.charAt(0).toUpperCase() + camelCase.slice(1);
};

// ../../node_modules/lucide-react/dist/esm/Icon.js
import { forwardRef, createElement } from "react";

// ../../node_modules/lucide-react/dist/esm/defaultAttributes.js
var defaultAttributes = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
};

// ../../node_modules/lucide-react/dist/esm/shared/src/utils/hasA11yProp.js
var hasA11yProp = (props) => {
  for (const prop in props) {
    if (prop.startsWith("aria-") || prop === "role" || prop === "title") {
      return true;
    }
  }
  return false;
};

// ../../node_modules/lucide-react/dist/esm/Icon.js
var Icon = forwardRef(
  ({
    color = "currentColor",
    size = 24,
    strokeWidth = 2,
    absoluteStrokeWidth,
    className = "",
    children,
    iconNode,
    ...rest
  }, ref) => createElement(
    "svg",
    {
      ref,
      ...defaultAttributes,
      width: size,
      height: size,
      stroke: color,
      strokeWidth: absoluteStrokeWidth ? Number(strokeWidth) * 24 / Number(size) : strokeWidth,
      className: mergeClasses("lucide", className),
      ...!children && !hasA11yProp(rest) && { "aria-hidden": "true" },
      ...rest
    },
    [
      ...iconNode.map(([tag, attrs]) => createElement(tag, attrs)),
      ...Array.isArray(children) ? children : [children]
    ]
  )
);

// ../../node_modules/lucide-react/dist/esm/createLucideIcon.js
var createLucideIcon = (iconName, iconNode) => {
  const Component = forwardRef2(
    ({ className, ...props }, ref) => createElement2(Icon, {
      ref,
      iconNode,
      className: mergeClasses(
        `lucide-${toKebabCase(toPascalCase(iconName))}`,
        `lucide-${iconName}`,
        className
      ),
      ...props
    })
  );
  Component.displayName = toPascalCase(iconName);
  return Component;
};

// ../../node_modules/lucide-react/dist/esm/icons/arrow-left.js
var __iconNode = [
  ["path", { d: "m12 19-7-7 7-7", key: "1l729n" }],
  ["path", { d: "M19 12H5", key: "x3x0zl" }]
];
var ArrowLeft = createLucideIcon("arrow-left", __iconNode);

// ../../node_modules/lucide-react/dist/esm/icons/calendar.js
var __iconNode2 = [
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["rect", { width: "18", height: "18", x: "3", y: "4", rx: "2", key: "1hopcy" }],
  ["path", { d: "M3 10h18", key: "8toen8" }]
];
var Calendar = createLucideIcon("calendar", __iconNode2);

// ../../node_modules/lucide-react/dist/esm/icons/chart-column.js
var __iconNode3 = [
  ["path", { d: "M3 3v16a2 2 0 0 0 2 2h16", key: "c24i48" }],
  ["path", { d: "M18 17V9", key: "2bz60n" }],
  ["path", { d: "M13 17V5", key: "1frdt8" }],
  ["path", { d: "M8 17v-3", key: "17ska0" }]
];
var ChartColumn = createLucideIcon("chart-column", __iconNode3);

// ../../node_modules/lucide-react/dist/esm/icons/circle-alert.js
var __iconNode4 = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["line", { x1: "12", x2: "12", y1: "8", y2: "12", key: "1pkeuh" }],
  ["line", { x1: "12", x2: "12.01", y1: "16", y2: "16", key: "4dfq90" }]
];
var CircleAlert = createLucideIcon("circle-alert", __iconNode4);

// ../../node_modules/lucide-react/dist/esm/icons/circle-check-big.js
var __iconNode5 = [
  ["path", { d: "M21.801 10A10 10 0 1 1 17 3.335", key: "yps3ct" }],
  ["path", { d: "m9 11 3 3L22 4", key: "1pflzl" }]
];
var CircleCheckBig = createLucideIcon("circle-check-big", __iconNode5);

// ../../node_modules/lucide-react/dist/esm/icons/circle-minus.js
var __iconNode6 = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M8 12h8", key: "1wcyev" }]
];
var CircleMinus = createLucideIcon("circle-minus", __iconNode6);

// ../../node_modules/lucide-react/dist/esm/icons/circle-x.js
var __iconNode7 = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m15 9-6 6", key: "1uzhvr" }],
  ["path", { d: "m9 9 6 6", key: "z0biqf" }]
];
var CircleX = createLucideIcon("circle-x", __iconNode7);

// ../../node_modules/lucide-react/dist/esm/icons/clock.js
var __iconNode8 = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M12 6v6l4 2", key: "mmk7yg" }]
];
var Clock = createLucideIcon("clock", __iconNode8);

// ../../node_modules/lucide-react/dist/esm/icons/eye-off.js
var __iconNode9 = [
  [
    "path",
    {
      d: "M10.733 5.076a10.744 10.744 0 0 1 11.205 6.575 1 1 0 0 1 0 .696 10.747 10.747 0 0 1-1.444 2.49",
      key: "ct8e1f"
    }
  ],
  ["path", { d: "M14.084 14.158a3 3 0 0 1-4.242-4.242", key: "151rxh" }],
  [
    "path",
    {
      d: "M17.479 17.499a10.75 10.75 0 0 1-15.417-5.151 1 1 0 0 1 0-.696 10.75 10.75 0 0 1 4.446-5.143",
      key: "13bj9a"
    }
  ],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }]
];
var EyeOff = createLucideIcon("eye-off", __iconNode9);

// ../../node_modules/lucide-react/dist/esm/icons/eye.js
var __iconNode10 = [
  [
    "path",
    {
      d: "M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0",
      key: "1nclc0"
    }
  ],
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }]
];
var Eye = createLucideIcon("eye", __iconNode10);

// ../../node_modules/lucide-react/dist/esm/icons/info.js
var __iconNode11 = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M12 16v-4", key: "1dtifu" }],
  ["path", { d: "M12 8h.01", key: "e9boi3" }]
];
var Info = createLucideIcon("info", __iconNode11);

// ../../node_modules/lucide-react/dist/esm/icons/mail.js
var __iconNode12 = [
  ["path", { d: "m22 7-8.991 5.727a2 2 0 0 1-2.009 0L2 7", key: "132q7q" }],
  ["rect", { x: "2", y: "4", width: "20", height: "16", rx: "2", key: "izxlao" }]
];
var Mail = createLucideIcon("mail", __iconNode12);

// ../../node_modules/lucide-react/dist/esm/icons/search.js
var __iconNode13 = [
  ["path", { d: "m21 21-4.34-4.34", key: "14j7rj" }],
  ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }]
];
var Search = createLucideIcon("search", __iconNode13);

// ../../node_modules/lucide-react/dist/esm/icons/trending-down.js
var __iconNode14 = [
  ["path", { d: "M16 17h6v-6", key: "t6n2it" }],
  ["path", { d: "m22 17-8.5-8.5-5 5L2 7", key: "x473p" }]
];
var TrendingDown = createLucideIcon("trending-down", __iconNode14);

// ../../node_modules/lucide-react/dist/esm/icons/trending-up.js
var __iconNode15 = [
  ["path", { d: "M16 7h6v6", key: "box55l" }],
  ["path", { d: "m22 7-8.5 8.5-5-5L2 17", key: "1t1m79" }]
];
var TrendingUp = createLucideIcon("trending-up", __iconNode15);

// ../../node_modules/lucide-react/dist/esm/icons/x.js
var __iconNode16 = [
  ["path", { d: "M18 6 6 18", key: "1bl5f8" }],
  ["path", { d: "m6 6 12 12", key: "d8bk6v" }]
];
var X = createLucideIcon("x", __iconNode16);

// src/components/forms/FormField.tsx
import { useState } from "react";

// src/components/forms/styles.ts
var formStyles = {
  label: "block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1",
  input: "block w-full rounded-lg border border-gray-300 px-3 py-2 text-sm text-gray-900 placeholder-gray-400 focus:border-primary-500 focus:outline-hidden focus:ring-1 focus:ring-primary-500 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-100 dark:placeholder-gray-600 dark:[color-scheme:dark]",
  textarea: "block w-full rounded-lg border border-gray-300 px-3 py-2 text-sm text-gray-900 placeholder-gray-400 focus:border-primary-500 focus:outline-hidden focus:ring-1 focus:ring-primary-500 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-100 dark:placeholder-gray-600",
  select: "block w-full rounded-lg border border-gray-300 px-3 py-2 text-sm text-gray-900 placeholder-gray-400 focus:border-primary-500 focus:outline-hidden focus:ring-1 focus:ring-primary-500 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-100 dark:placeholder-gray-600",
  checkbox: "w-4 h-4 text-primary-600 border-gray-300 rounded-sm focus:ring-primary-500 dark:border-gray-700 dark:bg-gray-800",
  radio: "w-4 h-4 text-primary-600 border-gray-300 focus:ring-primary-500 dark:border-gray-700 dark:bg-gray-800",
  error: "text-sm text-error-600 dark:text-error-400",
  helpText: "text-sm text-gray-500 dark:text-gray-500",
  required: "text-error-500 ml-1",
  disabled: "opacity-50 cursor-not-allowed"
};
var errorStyles = {
  input: "border-error-500 focus:border-error-500 focus:ring-error-500 dark:border-error-500",
  label: "text-error-600 dark:text-error-400"
};

// src/components/forms/FormField.tsx
import { jsx, jsxs } from "react/jsx-runtime";
function FormField({
  id,
  label,
  type = "text",
  inputMode,
  value,
  onChange,
  onBlur,
  placeholder,
  required = false,
  disabled = false,
  autoFocus = false,
  maxLength,
  minLength,
  icon: Icon2,
  helpText,
  error,
  className,
  inputClassName,
  labelClassName,
  labelAccessory,
  autoComplete,
  min,
  max,
  step,
  ref,
  showPasswordToggle = true,
  showPasswordLabel = "Show password",
  hidePasswordLabel = "Hide password"
}) {
  const [showPassword, setShowPassword] = useState(false);
  const isPasswordField = type === "password";
  const actualType = isPasswordField && showPassword ? "text" : type;
  const shouldShowToggle = isPasswordField && showPasswordToggle;
  return /* @__PURE__ */ jsxs("div", { className: cn("space-y-1", className), children: [
    /* @__PURE__ */ jsxs("label", { htmlFor: id, className: cn(formStyles.label, labelClassName), children: [
      label,
      required && /* @__PURE__ */ jsx("span", { className: formStyles.required, children: "*" }),
      labelAccessory
    ] }),
    /* @__PURE__ */ jsxs("div", { className: "relative", children: [
      Icon2 && /* @__PURE__ */ jsx("div", { className: "absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none", children: /* @__PURE__ */ jsx(Icon2, { className: "h-5 w-5 text-gray-400 dark:text-gray-500" }) }),
      /* @__PURE__ */ jsx(
        "input",
        {
          ref,
          id,
          name: id,
          type: actualType,
          inputMode,
          value,
          onChange: (e) => onChange(e.target.value),
          onBlur,
          onFocus: void 0,
          placeholder,
          required,
          disabled,
          autoFocus,
          maxLength,
          minLength,
          autoComplete,
          min,
          max,
          step,
          className: cn(
            formStyles.input,
            Icon2 && "pl-10",
            shouldShowToggle && "pr-10",
            error && errorStyles.input,
            inputClassName
          )
        }
      ),
      shouldShowToggle && /* @__PURE__ */ jsx(
        "button",
        {
          type: "button",
          onClick: () => setShowPassword(!showPassword),
          disabled,
          className: "absolute inset-y-0 right-0 pr-3 flex items-center text-gray-400 hover:text-gray-600 dark:text-gray-500 dark:hover:text-gray-300 transition-colors disabled:opacity-50 disabled:cursor-not-allowed",
          "aria-label": showPassword ? hidePasswordLabel : showPasswordLabel,
          "data-testid": `${id}-password-toggle`,
          children: showPassword ? /* @__PURE__ */ jsx(EyeOff, { className: "h-5 w-5", "aria-hidden": "true" }) : /* @__PURE__ */ jsx(Eye, { className: "h-5 w-5", "aria-hidden": "true" })
        }
      )
    ] }),
    helpText && !error && /* @__PURE__ */ jsx("p", { className: cn("mt-1", formStyles.helpText), children: helpText }),
    error && /* @__PURE__ */ jsx("p", { className: formStyles.error, children: error })
  ] });
}

// src/components/forms/FormButton.tsx
import { Fragment, jsx as jsx2, jsxs as jsxs2 } from "react/jsx-runtime";
function FormButton({
  type = "button",
  variant = "primary",
  loading = false,
  disabled = false,
  loadingText = "Loading...",
  icon: Icon2,
  iconPosition = "left",
  fullWidth = false,
  size = "md",
  children,
  className,
  onClick,
  ref,
  ...props
}) {
  const sizeClasses3 = {
    sm: "px-3 py-1.5 text-sm",
    md: "px-4 py-2 text-sm",
    lg: "px-6 py-3 text-base"
  };
  const variantClasses2 = {
    primary: "btn-primary",
    secondary: "btn-secondary",
    outline: "btn-outline",
    "outline-solid": "btn-outline",
    error: "btn-error",
    ghost: "btn-ghost"
  };
  return /* @__PURE__ */ jsx2(
    "button",
    {
      ref,
      type,
      disabled: disabled || loading,
      onClick,
      className: cn(
        "btn",
        variantClasses2[variant],
        sizeClasses3[size],
        fullWidth && "w-full",
        "inline-flex items-center justify-center",
        className
      ),
      ...props,
      children: loading ? /* @__PURE__ */ jsxs2(Fragment, { children: [
        /* @__PURE__ */ jsx2(
          "div",
          {
            className: cn(
              "loading-spinner",
              size === "sm" ? "w-3 h-3" : size === "lg" ? "w-5 h-5" : "w-4 h-4",
              "mr-2"
            )
          }
        ),
        loadingText
      ] }) : /* @__PURE__ */ jsxs2(Fragment, { children: [
        Icon2 && iconPosition === "left" && /* @__PURE__ */ jsx2(
          Icon2,
          {
            className: cn(
              size === "sm" ? "w-4 h-4" : size === "lg" ? "w-6 h-6" : "w-5 h-5",
              "mr-2"
            )
          }
        ),
        children,
        Icon2 && iconPosition === "right" && /* @__PURE__ */ jsx2(
          Icon2,
          {
            className: cn(
              size === "sm" ? "w-4 h-4" : size === "lg" ? "w-6 h-6" : "w-5 h-5",
              "ml-2"
            )
          }
        )
      ] })
    }
  );
}

// src/components/forms/FormError.tsx
import { jsx as jsx3 } from "react/jsx-runtime";
var FormError = ({
  error,
  className,
  t
}) => {
  if (!error) return null;
  const errorMessage = typeof error === "string" ? error : t ? t(error.key, error.params) : error.key;
  return /* @__PURE__ */ jsx3("div", { className: cn("alert-error", className), children: errorMessage });
};

// src/components/forms/FormSelect.tsx
import { jsx as jsx4, jsxs as jsxs3 } from "react/jsx-runtime";
function FormSelect({
  id,
  label,
  value,
  onChange,
  options,
  placeholder,
  required = false,
  disabled = false,
  helpText,
  error,
  className,
  selectClassName,
  labelClassName,
  ref
}) {
  return /* @__PURE__ */ jsxs3("div", { className: cn("space-y-1", className), children: [
    /* @__PURE__ */ jsxs3("label", { htmlFor: id, className: cn(formStyles.label, labelClassName), children: [
      label,
      required && /* @__PURE__ */ jsx4("span", { className: formStyles.required, children: "*" })
    ] }),
    /* @__PURE__ */ jsxs3(
      "select",
      {
        ref,
        id,
        value,
        onChange: (e) => onChange(e.target.value),
        required,
        disabled,
        className: cn(
          formStyles.select,
          "select",
          error && errorStyles.input,
          selectClassName
        ),
        children: [
          placeholder && /* @__PURE__ */ jsx4("option", { value: "", disabled: true, children: placeholder }),
          options.map((option) => /* @__PURE__ */ jsx4(
            "option",
            {
              value: option.value,
              disabled: option.disabled,
              children: option.label
            },
            option.value
          ))
        ]
      }
    ),
    helpText && !error && /* @__PURE__ */ jsx4("p", { className: formStyles.helpText, children: helpText }),
    error && /* @__PURE__ */ jsx4("p", { className: formStyles.error, children: error })
  ] });
}

// src/components/forms/FormTextarea.tsx
import { jsx as jsx5, jsxs as jsxs4 } from "react/jsx-runtime";
function FormTextarea({
  id,
  label,
  value,
  onChange,
  placeholder,
  required = false,
  disabled = false,
  rows = 3,
  maxLength,
  minLength,
  helpText,
  error,
  className,
  textareaClassName,
  labelClassName,
  resize = "vertical",
  "data-testid": dataTestId,
  ref
}) {
  const resizeClasses = {
    none: "resize-none",
    vertical: "resize-y",
    horizontal: "resize-x",
    both: "resize"
  };
  return /* @__PURE__ */ jsxs4("div", { className: cn("space-y-1", className), children: [
    /* @__PURE__ */ jsxs4("label", { htmlFor: id, className: cn(formStyles.label, labelClassName), children: [
      label,
      required && /* @__PURE__ */ jsx5("span", { className: formStyles.required, children: "*" })
    ] }),
    /* @__PURE__ */ jsx5(
      "textarea",
      {
        ref,
        id,
        value,
        onChange: (e) => onChange(e.target.value),
        placeholder,
        required,
        disabled,
        rows,
        maxLength,
        minLength,
        "data-testid": dataTestId,
        className: cn(
          formStyles.textarea,
          resizeClasses[resize],
          error && errorStyles.input,
          textareaClassName
        )
      }
    ),
    /* @__PURE__ */ jsxs4("div", { className: "flex justify-between items-center", children: [
      /* @__PURE__ */ jsxs4("div", { children: [
        helpText && !error && /* @__PURE__ */ jsx5("p", { className: cn("mt-1", formStyles.helpText), children: helpText }),
        error && /* @__PURE__ */ jsx5("p", { className: formStyles.error, children: error })
      ] }),
      maxLength && /* @__PURE__ */ jsxs4("p", { className: "text-sm text-gray-500 dark:text-gray-400", children: [
        value.length,
        "/",
        maxLength
      ] })
    ] })
  ] });
}

// src/components/forms/FormCheckbox.tsx
import { jsx as jsx6, jsxs as jsxs5 } from "react/jsx-runtime";
function FormCheckbox({
  id,
  label,
  checked,
  onChange,
  disabled = false,
  description,
  error,
  className,
  checkboxClassName,
  labelClassName,
  ref,
  "data-testid": dataTestId
}) {
  return /* @__PURE__ */ jsxs5("div", { className: cn("relative flex items-start", className), children: [
    /* @__PURE__ */ jsx6("div", { className: "flex items-center h-5", children: /* @__PURE__ */ jsx6(
      "input",
      {
        ref,
        id,
        type: "checkbox",
        checked,
        onChange: (e) => onChange(e.target.checked),
        disabled,
        "data-testid": dataTestId,
        className: cn(
          formStyles.checkbox,
          error && errorStyles.input,
          checkboxClassName
        )
      }
    ) }),
    /* @__PURE__ */ jsxs5("div", { className: "ml-3 text-sm", children: [
      /* @__PURE__ */ jsx6(
        "label",
        {
          htmlFor: id,
          className: cn(
            "font-medium text-gray-700 dark:text-gray-300",
            disabled && formStyles.disabled,
            labelClassName
          ),
          children: label
        }
      ),
      description && /* @__PURE__ */ jsx6("p", { className: formStyles.helpText, children: description }),
      error && /* @__PURE__ */ jsx6("p", { className: formStyles.error, children: error })
    ] })
  ] });
}

// src/components/forms/FormSection.tsx
import { jsx as jsx7, jsxs as jsxs6 } from "react/jsx-runtime";
var FormSection = ({
  title,
  description,
  icon: Icon2,
  required = false,
  children,
  className,
  titleClassName,
  bordered = true
}) => {
  return /* @__PURE__ */ jsxs6("div", { className: cn("space-y-4", className), children: [
    /* @__PURE__ */ jsxs6(
      "div",
      {
        className: cn(
          "flex items-center gap-2",
          bordered && "pb-2 border-b border-gray-200 dark:border-gray-700"
        ),
        children: [
          Icon2 && /* @__PURE__ */ jsx7(Icon2, { className: "w-5 h-5 text-gray-500 dark:text-gray-400" }),
          /* @__PURE__ */ jsxs6(
            "h3",
            {
              className: cn(
                "text-lg font-semibold text-gray-900 dark:text-white",
                titleClassName
              ),
              children: [
                title,
                required && /* @__PURE__ */ jsx7("span", { className: "text-error-500 ml-1", children: "*" })
              ]
            }
          )
        ]
      }
    ),
    description && /* @__PURE__ */ jsx7("p", { className: "text-sm text-gray-500 dark:text-gray-400 -mt-2", children: description }),
    /* @__PURE__ */ jsx7("div", { className: "space-y-4", children })
  ] });
};

// src/components/forms/FormSwitch.tsx
import { jsx as jsx8, jsxs as jsxs7 } from "react/jsx-runtime";
function FormSwitch({
  id,
  label,
  checked,
  onChange,
  disabled = false,
  description,
  className,
  switchClassName,
  labelClassName,
  "data-testid": dataTestId,
  ref
}) {
  const labelId = `${id}-label`;
  const switchId = `${id}-switch`;
  const descriptionId = description ? `${id}-description` : void 0;
  return /* @__PURE__ */ jsxs7("div", { className: cn("flex items-start", className), children: [
    /* @__PURE__ */ jsxs7("div", { className: "grow pr-4", children: [
      /* @__PURE__ */ jsx8(
        "label",
        {
          id: labelId,
          htmlFor: switchId,
          className: cn(
            "text-sm font-medium text-gray-900 dark:text-white cursor-pointer",
            disabled && "opacity-50",
            labelClassName
          ),
          children: label
        }
      ),
      description && /* @__PURE__ */ jsx8(
        "p",
        {
          id: descriptionId,
          className: "mt-2 text-sm text-gray-600 dark:text-gray-300 whitespace-pre-line leading-relaxed",
          children: description
        }
      )
    ] }),
    /* @__PURE__ */ jsx8("div", { className: "shrink-0", children: /* @__PURE__ */ jsx8(
      "button",
      {
        id: switchId,
        type: "button",
        role: "switch",
        "aria-checked": checked,
        "aria-labelledby": labelId,
        "aria-describedby": descriptionId,
        onClick: () => !disabled && onChange(!checked),
        className: cn(
          "relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-hidden focus:ring-2 focus:ring-orange-500 dark:focus:ring-orange-400 focus:ring-offset-2",
          checked ? "bg-orange-500 dark:bg-orange-400" : "bg-gray-200 dark:bg-gray-600",
          disabled && "opacity-50 cursor-not-allowed",
          switchClassName
        ),
        disabled,
        "data-testid": dataTestId,
        children: /* @__PURE__ */ jsx8(
          "span",
          {
            className: cn(
              "inline-block h-4 w-4 transform rounded-full bg-white transition-transform",
              checked ? "translate-x-6" : "translate-x-1"
            )
          }
        )
      }
    ) }),
    /* @__PURE__ */ jsx8(
      "input",
      {
        ref,
        id,
        type: "checkbox",
        className: "sr-only",
        tabIndex: -1,
        "aria-hidden": "true",
        checked,
        onChange: (e) => onChange(e.target.checked),
        disabled
      }
    )
  ] });
}

// src/components/ui/Button.tsx
import { Fragment as Fragment2, jsx as jsx9, jsxs as jsxs8 } from "react/jsx-runtime";
function Button({
  variant = "primary",
  size = "md",
  loading = false,
  disabled = false,
  fullWidth = false,
  leftIcon,
  rightIcon,
  children,
  className,
  type = "button",
  ref,
  ...props
}) {
  const sizeClasses3 = {
    sm: "px-3 py-1.5 text-sm",
    md: "px-4 py-2 text-sm",
    lg: "px-6 py-3 text-base"
  };
  const variantClasses2 = {
    primary: "btn-primary",
    secondary: "btn-secondary",
    ghost: "btn-ghost",
    danger: "btn-error",
    outline: "btn-outline",
    "outline-solid": "btn-outline",
    success: "btn-success",
    warning: "btn-warning"
  };
  return /* @__PURE__ */ jsx9(
    "button",
    {
      ref,
      type,
      disabled: disabled || loading,
      className: cn(
        "btn",
        variantClasses2[variant],
        sizeClasses3[size],
        fullWidth && "w-full",
        "inline-flex items-center justify-center",
        className
      ),
      ...props,
      children: loading ? /* @__PURE__ */ jsxs8(Fragment2, { children: [
        /* @__PURE__ */ jsx9(
          "div",
          {
            className: cn(
              "loading-spinner",
              size === "sm" ? "w-3 h-3" : size === "lg" ? "w-5 h-5" : "w-4 h-4",
              children && "mr-2"
            )
          }
        ),
        children
      ] }) : /* @__PURE__ */ jsxs8(Fragment2, { children: [
        leftIcon && /* @__PURE__ */ jsx9("span", { className: cn(children && "mr-2", "inline-flex"), children: leftIcon }),
        children,
        rightIcon && /* @__PURE__ */ jsx9("span", { className: cn(children && "ml-2", "inline-flex"), children: rightIcon })
      ] })
    }
  );
}

// src/components/ui/Card.tsx
import React2 from "react";
import { jsx as jsx10 } from "react/jsx-runtime";
var paddingClasses = {
  none: "",
  sm: "px-4 py-3",
  md: "px-6 py-4",
  lg: "px-8 py-6"
};
function Card({
  children,
  className,
  padding = "md",
  interactive = false,
  onClick,
  noHoverEffect = false,
  ref,
  ...props
}) {
  const Component = onClick ? "button" : "div";
  return React2.createElement(
    Component,
    {
      ref,
      onClick,
      className: cn(
        "card",
        !noHoverEffect && "transition-shadow duration-200 hover:shadow-lg",
        paddingClasses[padding],
        interactive && "cursor-pointer",
        onClick && "w-full text-left",
        className
      ),
      ...props
    },
    children
  );
}
var CardHeader = ({
  children,
  className
}) => /* @__PURE__ */ jsx10("div", { className: cn("mb-4", className), children });
var CardTitle = ({
  children,
  className
}) => /* @__PURE__ */ jsx10(
  "h3",
  {
    className: cn(
      "text-lg font-semibold text-gray-900 dark:text-gray-100",
      className
    ),
    children
  }
);
var CardDescription = ({
  children,
  className
}) => /* @__PURE__ */ jsx10("p", { className: cn("text-sm text-gray-500 dark:text-gray-300 mt-1", className), children });
var CardContent = ({
  children,
  className
}) => /* @__PURE__ */ jsx10("div", { className: cn("", className), children });
var CardFooter = ({
  children,
  className
}) => /* @__PURE__ */ jsx10("div", { className: cn("mt-6 flex items-center gap-4", className), children });

// src/components/ui/Alert.tsx
import { useEffect, useState as useState2 } from "react";
import { jsx as jsx11, jsxs as jsxs9 } from "react/jsx-runtime";
var defaultIcons = {
  error: (props) => /* @__PURE__ */ jsx11("svg", { className: props.className, fill: "currentColor", viewBox: "0 0 20 20", children: /* @__PURE__ */ jsx11(
    "path",
    {
      fillRule: "evenodd",
      d: "M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z",
      clipRule: "evenodd"
    }
  ) }),
  success: (props) => /* @__PURE__ */ jsx11("svg", { className: props.className, fill: "currentColor", viewBox: "0 0 20 20", children: /* @__PURE__ */ jsx11(
    "path",
    {
      fillRule: "evenodd",
      d: "M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z",
      clipRule: "evenodd"
    }
  ) }),
  warning: (props) => /* @__PURE__ */ jsx11("svg", { className: props.className, fill: "currentColor", viewBox: "0 0 20 20", children: /* @__PURE__ */ jsx11(
    "path",
    {
      fillRule: "evenodd",
      d: "M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z",
      clipRule: "evenodd"
    }
  ) }),
  info: (props) => /* @__PURE__ */ jsx11("svg", { className: props.className, fill: "currentColor", viewBox: "0 0 20 20", children: /* @__PURE__ */ jsx11(
    "path",
    {
      fillRule: "evenodd",
      d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z",
      clipRule: "evenodd"
    }
  ) })
};
var Alert = ({
  type,
  message,
  onDismiss,
  autoHide,
  className,
  icon,
  dismissLabel = "Dismiss",
  "data-testid": dataTestId
}) => {
  const [visible, setVisible] = useState2(true);
  useEffect(() => {
    if (autoHide && visible) {
      const timer = setTimeout(() => {
        setVisible(false);
        onDismiss?.();
      }, autoHide);
      return () => clearTimeout(timer);
    }
  }, [autoHide, visible, onDismiss]);
  if (!visible) return null;
  const typeClasses = {
    error: "alert-error",
    success: "alert-success",
    warning: "alert-warning",
    info: "alert-info"
  };
  const Icon2 = icon || defaultIcons[type];
  return /* @__PURE__ */ jsxs9(
    "div",
    {
      role: type === "error" ? "alert" : "status",
      "aria-live": type === "error" ? "assertive" : "polite",
      className: cn("alert", typeClasses[type], "flex", className),
      "data-testid": dataTestId,
      children: [
        /* @__PURE__ */ jsx11("div", { className: "shrink-0", "aria-hidden": "true", children: /* @__PURE__ */ jsx11(Icon2, { className: "h-5 w-5" }) }),
        /* @__PURE__ */ jsx11("div", { className: "ml-3 flex-1", children: /* @__PURE__ */ jsx11("div", { className: "text-sm", children: message }) }),
        onDismiss && /* @__PURE__ */ jsx11("div", { className: "ml-auto pl-3", children: /* @__PURE__ */ jsx11("div", { className: "-mx-1.5 -my-1.5", children: /* @__PURE__ */ jsx11(
          "button",
          {
            type: "button",
            onClick: () => {
              setVisible(false);
              onDismiss();
            },
            "aria-label": dismissLabel,
            className: "inline-flex rounded-md p-1.5 focus:outline-hidden focus:ring-2 focus:ring-offset-2 focus:ring-offset-transparent hover:bg-black/5",
            children: /* @__PURE__ */ jsx11(
              "svg",
              {
                className: "h-5 w-5",
                "aria-hidden": "true",
                viewBox: "0 0 20 20",
                fill: "currentColor",
                children: /* @__PURE__ */ jsx11(
                  "path",
                  {
                    fillRule: "evenodd",
                    d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
                    clipRule: "evenodd"
                  }
                )
              }
            )
          }
        ) }) })
      ]
    }
  );
};

// src/components/ui/Input.tsx
import { jsx as jsx12, jsxs as jsxs10 } from "react/jsx-runtime";
function Input({
  label,
  error,
  icon,
  rightElement,
  className,
  inputClassName,
  wrapperClassName,
  selectOnFocus,
  id,
  ref,
  ...props
}) {
  const inputId = id || label?.toLowerCase().replace(/\s+/g, "-");
  return /* @__PURE__ */ jsxs10("div", { className: cn("space-y-1", className), children: [
    label && /* @__PURE__ */ jsx12(
      "label",
      {
        htmlFor: inputId,
        className: "block text-sm font-medium text-gray-700 dark:text-gray-300",
        children: label
      }
    ),
    /* @__PURE__ */ jsxs10("div", { className: cn("relative", wrapperClassName), children: [
      icon && /* @__PURE__ */ jsx12("div", { className: "absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none", children: icon }),
      /* @__PURE__ */ jsx12(
        "input",
        {
          ref,
          id: inputId,
          className: cn(
            "input",
            icon && "pl-10",
            rightElement && "pr-10",
            error && "border-error-500 focus:border-error-500 focus:ring-error-500",
            inputClassName
          ),
          onFocus: selectOnFocus ? (e) => e.target.select() : props.onFocus,
          ...props
        }
      ),
      rightElement && /* @__PURE__ */ jsx12("div", { className: "absolute inset-y-0 right-0 pr-3 flex items-center", children: rightElement })
    ] }),
    error && /* @__PURE__ */ jsx12("p", { className: "text-sm text-error-600", children: error })
  ] });
}

// src/components/ui/IconButton.tsx
import { jsx as jsx13, jsxs as jsxs11 } from "react/jsx-runtime";
var variantStyles = {
  default: "bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700 border border-gray-200 dark:border-gray-700",
  primary: "bg-orange-500 text-white hover:bg-orange-600 dark:bg-orange-600 dark:hover:bg-orange-700",
  secondary: "bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-600",
  danger: "bg-red-500 text-white hover:bg-red-600 dark:bg-red-600 dark:hover:bg-red-700",
  success: "bg-green-500 text-white hover:bg-green-600 dark:bg-green-600 dark:hover:bg-green-700",
  ghost: "text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800"
};
var sizeStyles = {
  sm: "h-8 w-8 text-sm",
  md: "h-10 w-10 text-base",
  lg: "h-12 w-12 text-lg"
};
function IconButton({
  icon,
  variant = "default",
  size = "md",
  ariaLabel,
  isLoading = false,
  className,
  disabled,
  ref,
  ...props
}) {
  return /* @__PURE__ */ jsx13(
    "button",
    {
      ref,
      "aria-label": ariaLabel,
      disabled: disabled || isLoading,
      className: cn(
        "inline-flex items-center justify-center rounded-lg font-medium transition-colors",
        "focus:outline-hidden focus:ring-2 focus:ring-orange-500 focus:ring-offset-2",
        "disabled:opacity-50 disabled:cursor-not-allowed",
        variantStyles[variant],
        sizeStyles[size],
        className
      ),
      ...props,
      children: isLoading ? /* @__PURE__ */ jsxs11(
        "svg",
        {
          className: "animate-spin h-4 w-4",
          xmlns: "http://www.w3.org/2000/svg",
          fill: "none",
          viewBox: "0 0 24 24",
          children: [
            /* @__PURE__ */ jsx13(
              "circle",
              {
                className: "opacity-25",
                cx: "12",
                cy: "12",
                r: "10",
                stroke: "currentColor",
                strokeWidth: "4"
              }
            ),
            /* @__PURE__ */ jsx13(
              "path",
              {
                className: "opacity-75",
                fill: "currentColor",
                d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
              }
            )
          ]
        }
      ) : icon
    }
  );
}

// src/components/ui/SearchInput.tsx
import { useCallback, useEffect as useEffect2, useState as useState3 } from "react";
import { jsx as jsx14, jsxs as jsxs12 } from "react/jsx-runtime";
function SearchInput({
  value: controlledValue,
  onChange,
  onClear,
  placeholder = "Search...",
  debounce = 0,
  showClearButton = true,
  showSearchIcon = true,
  className,
  disabled,
  ref,
  ...props
}) {
  const [internalValue, setInternalValue] = useState3(controlledValue || "");
  const [debounceTimer, setDebounceTimer] = useState3(
    null
  );
  const value = controlledValue !== void 0 ? controlledValue : internalValue;
  useEffect2(() => {
    if (controlledValue !== void 0) {
      setInternalValue(controlledValue);
    }
  }, [controlledValue]);
  const handleChange = useCallback(
    (e) => {
      const newValue = e.target.value;
      setInternalValue(newValue);
      if (debounce > 0 && onChange) {
        if (debounceTimer) {
          clearTimeout(debounceTimer);
        }
        const timer = setTimeout(() => {
          onChange(newValue);
        }, debounce);
        setDebounceTimer(timer);
      } else if (onChange) {
        onChange(newValue);
      }
    },
    [onChange, debounce, debounceTimer]
  );
  const handleClear = useCallback(() => {
    setInternalValue("");
    if (onChange) {
      onChange("");
    }
    if (onClear) {
      onClear();
    }
    if (ref && "current" in ref && ref.current) {
      ref.current.focus();
    }
  }, [onChange, onClear, ref]);
  useEffect2(() => {
    return () => {
      if (debounceTimer) {
        clearTimeout(debounceTimer);
      }
    };
  }, [debounceTimer]);
  return /* @__PURE__ */ jsxs12("div", { className: "relative", children: [
    showSearchIcon && /* @__PURE__ */ jsx14("div", { className: "absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none", children: /* @__PURE__ */ jsx14(Search, { className: "h-4 w-4 text-gray-400", "aria-hidden": "true" }) }),
    /* @__PURE__ */ jsx14(
      "input",
      {
        ref,
        type: "text",
        value,
        onChange: handleChange,
        placeholder,
        disabled,
        className: cn(
          "block w-full rounded-lg border border-gray-200 dark:border-gray-700",
          "bg-white dark:bg-gray-800",
          "text-gray-900 dark:text-gray-100",
          "placeholder-gray-400 dark:placeholder-gray-500",
          "focus:outline-hidden focus:ring-2 focus:ring-orange-500 focus:border-transparent",
          "disabled:bg-gray-50 disabled:text-gray-500 disabled:cursor-not-allowed",
          "transition-colors duration-200",
          showSearchIcon && "pl-10",
          showClearButton && value && "pr-10",
          !showSearchIcon && !showClearButton && "px-3",
          "py-2",
          className
        ),
        ...props
      }
    ),
    showClearButton && value && !disabled && /* @__PURE__ */ jsx14(
      "button",
      {
        type: "button",
        onClick: handleClear,
        className: cn(
          "absolute inset-y-0 right-0 flex items-center pr-3",
          "text-gray-400 hover:text-gray-600 dark:hover:text-gray-300",
          "transition-colors duration-200"
        ),
        "aria-label": "Clear search",
        children: /* @__PURE__ */ jsx14(X, { className: "h-4 w-4", "aria-hidden": "true" })
      }
    )
  ] });
}

// src/components/data-display/Avatar.tsx
import { useState as useState4 } from "react";
import { DELETED_USER_SENTINEL } from "@splitfiesta/shared";
import { jsx as jsx15 } from "react/jsx-runtime";
var sizeClasses = {
  xs: "w-6 h-6 text-xs",
  sm: "w-8 h-8 text-sm",
  md: "w-10 h-10 text-base",
  lg: "w-12 h-12 text-lg",
  xl: "w-16 h-16 text-xl"
};
var getInitials = (name) => {
  if (!name || name === DELETED_USER_SENTINEL) return "?";
  const words = name.trim().split(" ");
  if (words.length === 1) {
    return words[0].charAt(0).toUpperCase();
  }
  return (words[0].charAt(0) + words[words.length - 1].charAt(0)).toUpperCase();
};
var getBackgroundColor = (_name) => {
  return "bg-gray-100 dark:bg-gray-700";
};
var Avatar = ({
  src,
  name,
  size = "md",
  className,
  onClick
}) => {
  const [imageError, setImageError] = useState4(false);
  const Component = onClick ? "button" : "div";
  const showInitials = !src || imageError;
  if (!showInitials) {
    return /* @__PURE__ */ jsx15(
      Component,
      {
        onClick,
        className: cn(
          "relative rounded-full overflow-hidden",
          sizeClasses[size],
          onClick && "cursor-pointer hover:opacity-90 transition-opacity",
          className
        ),
        children: /* @__PURE__ */ jsx15(
          "img",
          {
            src,
            alt: name,
            className: "w-full h-full object-cover",
            onError: () => setImageError(true)
          }
        )
      }
    );
  }
  return /* @__PURE__ */ jsx15(
    Component,
    {
      onClick,
      className: cn(
        "relative inline-flex items-center justify-center rounded-full text-gray-700 dark:text-gray-300 font-medium",
        sizeClasses[size],
        getBackgroundColor(name),
        onClick && "cursor-pointer hover:opacity-90 transition-opacity",
        className
      ),
      children: getInitials(name)
    }
  );
};

// src/components/data-display/Badge.tsx
import { jsx as jsx16 } from "react/jsx-runtime";
var variantClasses = {
  primary: "bg-primary-100 text-primary-800 dark:bg-primary-900/30 dark:text-primary-300",
  success: "bg-success-100 text-success-800 dark:bg-success-900/30 dark:text-success-300",
  warning: "bg-warning-100 text-warning-800 dark:bg-warning-900/30 dark:text-warning-300",
  danger: "bg-error-100 text-error-800 dark:bg-red-950/40 dark:text-red-400",
  neutral: "bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-200",
  info: "bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-300"
};
var sizeClasses2 = {
  sm: "px-2 py-0.5 text-xs",
  md: "px-2.5 py-0.5 text-sm"
};
var Badge = ({
  variant = "neutral",
  size = "md",
  children,
  className,
  rounded = false
}) => {
  return /* @__PURE__ */ jsx16(
    "span",
    {
      className: cn(
        "inline-flex items-center font-medium",
        rounded ? "rounded-full" : "rounded-sm",
        variantClasses[variant],
        sizeClasses2[size],
        className
      ),
      children
    }
  );
};

// src/components/data-display/EmptyState.tsx
import { jsx as jsx17, jsxs as jsxs13 } from "react/jsx-runtime";
var EmptyState = ({
  icon,
  title,
  description,
  action,
  className
}) => {
  return /* @__PURE__ */ jsxs13("div", { className: cn("text-center py-12", className), children: [
    icon && /* @__PURE__ */ jsx17("div", { className: "mx-auto h-12 w-12 text-gray-400 dark:text-gray-500 mb-4", children: icon }),
    /* @__PURE__ */ jsx17("h3", { className: "mt-2 text-sm font-medium text-gray-900 dark:text-gray-100", children: title }),
    description && /* @__PURE__ */ jsx17("p", { className: "mt-1 text-sm text-gray-500 dark:text-gray-400", children: description }),
    action && /* @__PURE__ */ jsx17("div", { className: "mt-6", children: /* @__PURE__ */ jsx17(
      Button,
      {
        variant: "primary",
        onClick: action.onClick,
        leftIcon: action.icon,
        children: action.label
      }
    ) })
  ] });
};

// src/components/data-display/Skeleton.tsx
import { jsx as jsx18 } from "react/jsx-runtime";
var Skeleton = ({
  variant = "text",
  width,
  height,
  count = 1,
  className,
  containerClassName
}) => {
  const getVariantClasses = () => {
    switch (variant) {
      case "circle":
        return "rounded-full";
      case "rect":
        return "rounded-sm";
      case "text":
      default:
        return "rounded-sm";
    }
  };
  const getVariantStyles = () => {
    const styles = {};
    if (width) {
      styles.width = typeof width === "number" ? `${width}px` : width;
    }
    if (height) {
      styles.height = typeof height === "number" ? `${height}px` : height;
    }
    if (variant === "text" && !height) {
      styles.height = "1em";
    }
    if (variant === "circle" && !height && width) {
      styles.height = styles.width;
    }
    return styles;
  };
  const skeletons = Array.from({ length: count }, (_, index) => /* @__PURE__ */ jsx18(
    "div",
    {
      className: cn(
        "skeleton",
        getVariantClasses(),
        variant === "text" && !width && "w-full",
        className
      ),
      style: getVariantStyles()
    },
    index
  ));
  if (count > 1) {
    return /* @__PURE__ */ jsx18("div", { className: cn("space-y-2", containerClassName), children: skeletons });
  }
  return skeletons[0];
};

// src/components/data-display/StatCard.tsx
import { jsx as jsx19, jsxs as jsxs14 } from "react/jsx-runtime";
var StatCard = ({
  icon,
  iconColor = "text-orange-600",
  label,
  value,
  valueColor = "text-gray-900",
  onClick,
  className,
  interactive = false
}) => {
  return /* @__PURE__ */ jsx19(
    Card,
    {
      className: cn(
        "relative",
        onClick && "cursor-pointer hover:shadow-md transition-shadow",
        className
      ),
      interactive: interactive || !!onClick,
      onClick,
      padding: "md",
      children: /* @__PURE__ */ jsxs14("div", { className: "flex items-center w-full text-left", children: [
        /* @__PURE__ */ jsx19("div", { className: cn("shrink-0", iconColor), children: icon }),
        /* @__PURE__ */ jsxs14("div", { className: "ml-4", children: [
          /* @__PURE__ */ jsx19("div", { className: "text-sm font-medium text-gray-500 dark:text-gray-400", children: label }),
          /* @__PURE__ */ jsx19("div", { className: cn("text-2xl font-bold dark:text-white", valueColor), children: value })
        ] })
      ] })
    }
  );
};

// src/components/typography/Heading.tsx
import React6 from "react";

// src/components/typography/styles.ts
var typographyStyles = {
  // Headings with proper dark mode contrast ratios
  h1: "text-4xl font-bold text-gray-900 dark:text-gray-100 leading-tight tracking-tight",
  h2: "text-3xl font-semibold text-gray-900 dark:text-gray-100 leading-tight",
  h3: "text-2xl font-semibold text-gray-800 dark:text-gray-200 leading-tight",
  h4: "text-xl font-medium text-gray-800 dark:text-gray-200",
  h5: "text-lg font-medium text-gray-700 dark:text-gray-300",
  // Body text variants
  body: "text-base text-gray-700 dark:text-gray-300",
  bodySmall: "text-sm text-gray-600 dark:text-gray-400",
  bodyLarge: "text-lg text-gray-700 dark:text-gray-300",
  // Special purpose text
  lead: "text-xl text-gray-700 dark:text-gray-300 leading-relaxed",
  muted: "text-sm text-gray-500 dark:text-gray-500",
  caption: "text-xs text-gray-500 dark:text-gray-500",
  // Links
  link: "text-primary-600 hover:text-primary-700 dark:text-primary-400 dark:hover:text-primary-300 underline-offset-2 hover:underline",
  linkSubtle: "text-gray-600 hover:text-gray-900 dark:text-gray-400 dark:hover:text-gray-100"
};

// src/components/typography/Heading.tsx
function H1({
  children,
  className,
  as: Component = "h1",
  ref,
  ...props
}) {
  return React6.createElement(
    Component,
    {
      ref,
      className: cn(typographyStyles.h1, className),
      ...props
    },
    children
  );
}
function H2({
  children,
  className,
  as: Component = "h2",
  ref,
  ...props
}) {
  return React6.createElement(
    Component,
    {
      ref,
      className: cn(typographyStyles.h2, className),
      ...props
    },
    children
  );
}
function H3({
  children,
  className,
  as: Component = "h3",
  ref,
  ...props
}) {
  return React6.createElement(
    Component,
    {
      ref,
      className: cn(typographyStyles.h3, className),
      ...props
    },
    children
  );
}
function H4({
  children,
  className,
  as: Component = "h4",
  ref,
  ...props
}) {
  return React6.createElement(
    Component,
    {
      ref,
      className: cn(typographyStyles.h4, className),
      ...props
    },
    children
  );
}
function H5({
  children,
  className,
  as: Component = "h5",
  ref,
  ...props
}) {
  return React6.createElement(
    Component,
    {
      ref,
      className: cn(typographyStyles.h5, className),
      ...props
    },
    children
  );
}

// src/components/layout/PageHeader.tsx
import { jsx as jsx20, jsxs as jsxs15 } from "react/jsx-runtime";
function PageHeader({
  title,
  subtitle,
  backButton,
  actions,
  className = ""
}) {
  return /* @__PURE__ */ jsxs15("div", { className: `flex items-center justify-between mb-8 ${className}`, children: [
    /* @__PURE__ */ jsxs15("div", { className: "flex items-center min-w-0 flex-1", children: [
      backButton && /* @__PURE__ */ jsx20("div", { className: "mr-4", children: backButton.href ? /* @__PURE__ */ jsx20(
        "a",
        {
          href: backButton.href,
          className: "p-2 rounded-lg hover:bg-gray-100 transition-colors",
          children: /* @__PURE__ */ jsx20(ArrowLeft, { className: "w-5 h-5 text-gray-600" })
        }
      ) : /* @__PURE__ */ jsx20(
        "button",
        {
          onClick: backButton.onClick,
          className: "p-2 rounded-lg hover:bg-gray-100 transition-colors",
          children: /* @__PURE__ */ jsx20(ArrowLeft, { className: "w-5 h-5 text-gray-600" })
        }
      ) }),
      /* @__PURE__ */ jsxs15("div", { className: "min-w-0 flex-1", children: [
        /* @__PURE__ */ jsx20(H1, { className: "text-3xl", children: title }),
        subtitle && /* @__PURE__ */ jsx20("p", { className: "mt-1 text-sm text-gray-500", children: subtitle })
      ] })
    ] }),
    actions && /* @__PURE__ */ jsx20("div", { className: "ml-4 shrink-0", children: actions })
  ] });
}

// src/components/layout/SectionHeader.tsx
import { jsx as jsx21, jsxs as jsxs16 } from "react/jsx-runtime";
function SectionHeader({
  title,
  description,
  icon,
  actions,
  size = "md",
  bordered = true,
  className = ""
}) {
  const sizeClasses3 = {
    sm: "text-base",
    md: "text-lg",
    lg: "text-xl"
  };
  const spacingClasses = {
    sm: "mb-3",
    md: "mb-4",
    lg: "mb-6"
  };
  return /* @__PURE__ */ jsxs16(
    "div",
    {
      className: `flex items-center justify-between ${spacingClasses[size]} ${className}`,
      children: [
        /* @__PURE__ */ jsxs16("div", { className: "flex items-center min-w-0 flex-1", children: [
          icon && /* @__PURE__ */ jsx21("div", { className: "mr-2 shrink-0", children: icon }),
          /* @__PURE__ */ jsxs16("div", { className: "min-w-0 flex-1", children: [
            /* @__PURE__ */ jsx21(
              "h3",
              {
                className: `font-semibold text-gray-900 ${sizeClasses3[size]} ${bordered ? "pb-2 border-b border-gray-200" : ""}`,
                children: title
              }
            ),
            description && /* @__PURE__ */ jsx21("p", { className: "mt-1 text-sm text-gray-600", children: description })
          ] })
        ] }),
        actions && /* @__PURE__ */ jsx21("div", { className: "ml-4 shrink-0", children: actions })
      ]
    }
  );
}

// src/components/layout/GridLayout.tsx
import { jsx as jsx22 } from "react/jsx-runtime";
function GridLayout({
  columns = { xs: 1, sm: 2, md: 3, lg: 4, xl: 4 },
  gap = "md",
  children,
  className = ""
}) {
  const gapClasses = {
    sm: "gap-2",
    md: "gap-4",
    lg: "gap-6",
    xl: "gap-8"
  };
  const gridClasses = [
    "grid",
    gapClasses[gap],
    columns.xs && `grid-cols-${columns.xs}`,
    columns.sm && `sm:grid-cols-${columns.sm}`,
    columns.md && `md:grid-cols-${columns.md}`,
    columns.lg && `lg:grid-cols-${columns.lg}`,
    columns.xl && `xl:grid-cols-${columns.xl}`
  ].filter(Boolean).join(" ");
  return /* @__PURE__ */ jsx22("div", { className: `${gridClasses} ${className}`, children });
}

// src/components/layout/PageContainer.tsx
import { jsx as jsx23 } from "react/jsx-runtime";
function PageContainer({
  children,
  maxWidth = "7xl",
  padding = "md",
  className = ""
}) {
  const maxWidthClasses = {
    sm: "max-w-sm",
    md: "max-w-md",
    lg: "max-w-lg",
    xl: "max-w-xl",
    "2xl": "max-w-2xl",
    "4xl": "max-w-4xl",
    "6xl": "max-w-6xl",
    "7xl": "max-w-7xl",
    full: "max-w-full"
  };
  const paddingClasses2 = {
    sm: "py-4 px-4 sm:px-6",
    md: "py-6 px-4 sm:px-6 lg:px-8",
    lg: "py-8 px-4 sm:px-6 lg:px-8",
    xl: "py-12 px-4 sm:px-6 lg:px-8"
  };
  return /* @__PURE__ */ jsx23(
    "div",
    {
      className: `${maxWidthClasses[maxWidth]} mx-auto ${paddingClasses2[padding]} ${className}`,
      children
    }
  );
}

// src/components/specialized/DateDisplay.tsx
import { jsx as jsx24, jsxs as jsxs17 } from "react/jsx-runtime";
function DateDisplay({
  date,
  format = "short",
  showIcon = false,
  locale = "en-US",
  className = ""
}) {
  const dateObj = new Date(date);
  if (isNaN(dateObj.getTime())) {
    return /* @__PURE__ */ jsxs17("span", { className: `text-gray-500 ${className}`, children: [
      showIcon && /* @__PURE__ */ jsx24(Calendar, { className: "w-4 h-4 inline mr-1" }),
      "Invalid date"
    ] });
  }
  const formatDate = () => {
    const now = /* @__PURE__ */ new Date();
    const diffMs = now.getTime() - dateObj.getTime();
    const diffDays = Math.floor(diffMs / (1e3 * 60 * 60 * 24));
    switch (format) {
      case "relative":
        if (diffDays === 0) return "Today";
        if (diffDays === 1) return "Yesterday";
        if (diffDays === -1) return "Tomorrow";
        if (diffDays > 0 && diffDays < 7) return `${diffDays} days ago`;
        if (diffDays < 0 && diffDays > -7)
          return `In ${Math.abs(diffDays)} days`;
        return dateObj.toLocaleDateString(locale, {
          month: "short",
          day: "numeric",
          year: diffDays > 365 || diffDays < -365 ? "numeric" : void 0
        });
      case "short":
        return dateObj.toLocaleDateString(locale, {
          month: "short",
          day: "numeric",
          year: "numeric"
        });
      case "long":
        return dateObj.toLocaleDateString(locale, {
          weekday: "long",
          year: "numeric",
          month: "long",
          day: "numeric"
        });
      case "full":
        return dateObj.toLocaleDateString(locale, {
          weekday: "long",
          year: "numeric",
          month: "long",
          day: "numeric",
          hour: "2-digit",
          minute: "2-digit"
        });
      default:
        return dateObj.toLocaleDateString(locale);
    }
  };
  return /* @__PURE__ */ jsxs17(
    "span",
    {
      className: `inline-flex items-center text-sm text-gray-600 ${className}`,
      children: [
        showIcon && /* @__PURE__ */ jsx24(Calendar, { className: "w-4 h-4 mr-1" }),
        formatDate()
      ]
    }
  );
}

// src/components/specialized/BalanceDisplay.tsx
import { jsx as jsx25, jsxs as jsxs18 } from "react/jsx-runtime";
function BalanceDisplay({
  amount,
  currency = "USD",
  showIcon = false,
  showPrefix = false,
  colorScheme = "success-error",
  size = "md",
  locale = "en-US",
  className = ""
}) {
  const formatAmount = (value) => {
    try {
      return new Intl.NumberFormat(locale, {
        style: "currency",
        currency,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(Math.abs(value));
    } catch {
      return `${Math.abs(value).toFixed(2)} ${currency}`;
    }
  };
  const getColorClass = () => {
    if (colorScheme === "muted") return "text-gray-600";
    if (colorScheme === "default") return "text-gray-900";
    if (amount > 0) return "text-green-600";
    if (amount < 0) return "text-red-600";
    return "text-gray-600";
  };
  const getSizeClass = () => {
    switch (size) {
      case "sm":
        return "text-sm";
      case "md":
        return "text-base";
      case "lg":
        return "text-lg";
      default:
        return "text-base";
    }
  };
  const getIcon = () => {
    if (!showIcon) return null;
    if (amount > 0) return /* @__PURE__ */ jsx25(TrendingUp, { className: "w-4 h-4 mr-1" });
    if (amount < 0) return /* @__PURE__ */ jsx25(TrendingDown, { className: "w-4 h-4 mr-1" });
    return /* @__PURE__ */ jsx25(ChartColumn, { className: "w-4 h-4 mr-1" });
  };
  const getPrefix = () => {
    if (!showPrefix) return "";
    if (amount > 0) return "+";
    if (amount < 0) return "-";
    return "";
  };
  return /* @__PURE__ */ jsxs18(
    "span",
    {
      className: `inline-flex items-center font-medium ${getColorClass()} ${getSizeClass()} ${className}`,
      children: [
        getIcon(),
        getPrefix(),
        formatAmount(amount)
      ]
    }
  );
}

// src/components/specialized/StatusBadge.tsx
import { jsx as jsx26, jsxs as jsxs19 } from "react/jsx-runtime";
function StatusBadge({
  status,
  children,
  size = "md",
  showIcon = true,
  className = ""
}) {
  const getStatusConfig = () => {
    switch (status) {
      case "success":
        return {
          bgColor: "bg-green-100",
          textColor: "text-green-800",
          icon: CircleCheckBig
        };
      case "error":
        return {
          bgColor: "bg-red-100",
          textColor: "text-red-800",
          icon: CircleX
        };
      case "warning":
        return {
          bgColor: "bg-yellow-100",
          textColor: "text-yellow-800",
          icon: CircleAlert
        };
      case "info":
        return {
          bgColor: "bg-blue-100",
          textColor: "text-blue-800",
          icon: Info
        };
      case "pending":
        return {
          bgColor: "bg-gray-100",
          textColor: "text-gray-800",
          icon: Clock
        };
      case "neutral":
        return {
          bgColor: "bg-gray-100",
          textColor: "text-gray-800",
          icon: CircleMinus
        };
      default:
        return {
          bgColor: "bg-gray-100",
          textColor: "text-gray-800",
          icon: CircleMinus
        };
    }
  };
  const getSizeClasses = () => {
    switch (size) {
      case "sm":
        return {
          padding: "px-2 py-1",
          text: "text-xs",
          icon: "w-3 h-3"
        };
      case "md":
        return {
          padding: "px-2.5 py-1.5",
          text: "text-sm",
          icon: "w-4 h-4"
        };
      case "lg":
        return {
          padding: "px-3 py-2",
          text: "text-base",
          icon: "w-5 h-5"
        };
      default:
        return {
          padding: "px-2.5 py-1.5",
          text: "text-sm",
          icon: "w-4 h-4"
        };
    }
  };
  const config = getStatusConfig();
  const sizeClasses3 = getSizeClasses();
  const Icon2 = config.icon;
  return /* @__PURE__ */ jsxs19(
    "span",
    {
      className: `
      inline-flex items-center font-medium rounded-full
      ${config.bgColor} ${config.textColor}
      ${sizeClasses3.padding} ${sizeClasses3.text}
      ${className}
    `,
      children: [
        showIcon && /* @__PURE__ */ jsx26(Icon2, { className: `${sizeClasses3.icon} mr-1` }),
        children
      ]
    }
  );
}

// src/components/specialized/UserDisplay.tsx
import { jsx as jsx27, jsxs as jsxs20 } from "react/jsx-runtime";
function UserDisplay({
  user,
  variant = "full",
  size = "md",
  showEmail = false,
  showAvatar = true,
  clickable = false,
  onClick,
  className = ""
}) {
  const getSizeClasses = () => {
    switch (size) {
      case "sm":
        return {
          avatar: "w-6 h-6",
          text: "text-sm",
          email: "text-xs"
        };
      case "md":
        return {
          avatar: "w-8 h-8",
          text: "text-base",
          email: "text-sm"
        };
      case "lg":
        return {
          avatar: "w-10 h-10",
          text: "text-lg",
          email: "text-base"
        };
      default:
        return {
          avatar: "w-8 h-8",
          text: "text-base",
          email: "text-sm"
        };
    }
  };
  const sizeClasses3 = getSizeClasses();
  const renderAvatar = () => {
    if (!showAvatar || variant === "name-only") return null;
    const avatarSize = size === "sm" ? "xs" : size === "md" ? "sm" : "md";
    return /* @__PURE__ */ jsx27(
      Avatar,
      {
        name: user.name,
        src: user.avatar,
        size: avatarSize,
        className: "shrink-0"
      }
    );
  };
  const renderContent = () => {
    if (variant === "avatar-only") return null;
    return /* @__PURE__ */ jsxs20("div", { className: "min-w-0 flex-1", children: [
      /* @__PURE__ */ jsx27(
        "div",
        {
          className: `font-medium text-gray-900 truncate ${sizeClasses3.text}`,
          children: user.name
        }
      ),
      (showEmail || variant === "full") && user.email && /* @__PURE__ */ jsxs20(
        "div",
        {
          className: `text-gray-500 truncate ${sizeClasses3.email} flex items-center mt-1`,
          children: [
            /* @__PURE__ */ jsx27(Mail, { className: "w-3 h-3 mr-1 shrink-0" }),
            user.email
          ]
        }
      )
    ] });
  };
  const baseClasses = `
    flex items-center space-x-3
    ${clickable ? "cursor-pointer hover:bg-gray-50 p-2 rounded-lg transition-colors" : ""}
    ${className}
  `;
  if (variant === "compact") {
    return /* @__PURE__ */ jsxs20(
      "div",
      {
        className: `flex items-center space-x-2 ${className}`,
        onClick,
        children: [
          renderAvatar(),
          /* @__PURE__ */ jsx27(
            "span",
            {
              className: `font-medium text-gray-900 truncate ${sizeClasses3.text}`,
              children: user.name
            }
          )
        ]
      }
    );
  }
  return /* @__PURE__ */ jsxs20("div", { className: baseClasses, onClick, children: [
    renderAvatar(),
    renderContent()
  ] });
}

// src/components/typography/Text.tsx
import React7 from "react";
import { jsx as jsx28 } from "react/jsx-runtime";
function Text({
  children,
  className,
  variant = "body",
  as: Component = "p",
  ref,
  ...props
}) {
  return React7.createElement(
    Component,
    {
      ref,
      className: cn(typographyStyles[variant], className),
      ...props
    },
    children
  );
}
function Lead({
  children,
  className,
  as = "p",
  ref,
  ...props
}) {
  return /* @__PURE__ */ jsx28(Text, { ref, variant: "lead", as, className, ...props, children });
}
function Muted({
  children,
  className,
  as = "span",
  ref,
  ...props
}) {
  return /* @__PURE__ */ jsx28(Text, { ref, variant: "muted", as, className, ...props, children });
}
function Caption({
  children,
  className,
  as = "span",
  ref,
  ...props
}) {
  return /* @__PURE__ */ jsx28(Text, { ref, variant: "caption", as, className, ...props, children });
}
export {
  Alert,
  Avatar,
  Badge,
  BalanceDisplay,
  Button,
  Caption,
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
  DateDisplay,
  EmptyState,
  FormButton,
  FormCheckbox,
  FormError,
  FormField,
  FormSection,
  FormSelect,
  FormSwitch,
  FormTextarea,
  GridLayout,
  H1,
  H2,
  H3,
  H4,
  H5,
  IconButton,
  Input,
  Lead,
  Muted,
  PageContainer,
  PageHeader,
  SearchInput,
  SectionHeader,
  Skeleton,
  StatCard,
  StatusBadge,
  Text,
  UserDisplay,
  cn,
  errorStyles,
  formStyles,
  typographyStyles
};
/*! Bundled license information:

lucide-react/dist/esm/shared/src/utils/mergeClasses.js:
lucide-react/dist/esm/shared/src/utils/toKebabCase.js:
lucide-react/dist/esm/shared/src/utils/toCamelCase.js:
lucide-react/dist/esm/shared/src/utils/toPascalCase.js:
lucide-react/dist/esm/defaultAttributes.js:
lucide-react/dist/esm/shared/src/utils/hasA11yProp.js:
lucide-react/dist/esm/Icon.js:
lucide-react/dist/esm/createLucideIcon.js:
lucide-react/dist/esm/icons/arrow-left.js:
lucide-react/dist/esm/icons/calendar.js:
lucide-react/dist/esm/icons/chart-column.js:
lucide-react/dist/esm/icons/circle-alert.js:
lucide-react/dist/esm/icons/circle-check-big.js:
lucide-react/dist/esm/icons/circle-minus.js:
lucide-react/dist/esm/icons/circle-x.js:
lucide-react/dist/esm/icons/clock.js:
lucide-react/dist/esm/icons/eye-off.js:
lucide-react/dist/esm/icons/eye.js:
lucide-react/dist/esm/icons/info.js:
lucide-react/dist/esm/icons/mail.js:
lucide-react/dist/esm/icons/search.js:
lucide-react/dist/esm/icons/trending-down.js:
lucide-react/dist/esm/icons/trending-up.js:
lucide-react/dist/esm/icons/x.js:
lucide-react/dist/esm/lucide-react.js:
  (**
   * @license lucide-react v0.577.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   *)
*/
